import tracking from '@g4/g4-analytics';

export default (path, title) => {
  if (process.browser) {
    tracking.trackPageView('', path, title);
  }
};
